<script lang="ts">
	import { getContext } from 'svelte'
	import { t } from '$i18n/i18n'
	import { fade } from 'svelte/transition'
	import { CalcMethod } from '$types/enums'
	import OfferReactionButton from './OfferReactionButton.svelte'
	import { OfferReactionButtons } from '#lib/bid/types/offer.js'
	import type { Writable } from 'svelte/store'
	import Notification from '#lib/molecules/Notification.svelte'
	import { NotificationType } from '$types/notification'

	interface Props {
		calcMethod: CalcMethod
		onAcceptOffer: () => void
		onDeclineOffer: () => void
		onEditOffer: () => void
	}

	let { calcMethod, onAcceptOffer, onDeclineOffer, onEditOffer }: Props = $props()

	const hasOfferFromOtherUser: Writable<boolean> = getContext('hasOfferFromOtherUser')
</script>

<div class="row" style="margin-top: 1.875rem">
	<div class="col-lg-12 col-sm-12">
		<div class="container-offer-reaction" in:fade={{ duration: 400 }}>
			<span>{$t('UI.Decisions.select.request.customer')}</span>
			{#if $hasOfferFromOtherUser}
				<Notification
					type={NotificationType.INFO}
					message={$t('UI.optimizerPage.offer.existsFromOtherUser')}
				/>
			{/if}
			{#if calcMethod === CalcMethod.NORMAL}
				<div class="counter-offer">
					<OfferReactionButton
						label={$t('UI.optimizerPage.buttons.accept')}
						reaction={OfferReactionButtons.POSITIVE}
						tooltipMsg={$t('UI.optimizerPage.buttons.accept.info')}
						onReactionBtnClick={onAcceptOffer}
					/>
					<OfferReactionButton
						label={$t('UI.optimizerPage.buttons.counteroffer')}
						reaction={OfferReactionButtons.NEUTRAL}
						tooltipMsg={$t('UI.optimizerPage.buttons.counteroffer.info')}
						onReactionBtnClick={onEditOffer}
					/>
					<OfferReactionButton
						label={$t('UI.optimizerPage.buttons.decline')}
						reaction={OfferReactionButtons.NEGATIVE}
						tooltipMsg={$t('UI.optimizerPage.buttons.decline.info')}
						onReactionBtnClick={onDeclineOffer}
					/>
				</div>
			{/if}
			{#if calcMethod === CalcMethod.REQUEST_OFFER}
				<div class="request-offer">
					<OfferReactionButton
						label={$t('UI.optimizerPage.buttons.offer')}
						reaction={OfferReactionButtons.POSITIVE}
						onReactionBtnClick={onEditOffer}
					/>
					<OfferReactionButton
						label={$t('UI.optimizerPage.buttons.decline')}
						reaction={OfferReactionButtons.NEGATIVE}
						onReactionBtnClick={onDeclineOffer}
					/>
				</div>
			{/if}
		</div>
	</div>
</div>

<style lang="scss">
	@import '$styles/global';

	.container-offer-reaction {
		@include flex-col(1rem, $alignment: flex-start);

		& > span:first-child {
			@include roboto-font(15px, 500, 1rem, black);

			text-align: left;
		}

		& > div.request-offer {
			display: grid;
			grid-template-columns: 1fr 1fr;
			column-gap: 1.438rem;
			grid-auto-rows: 1fr;
			width: 100%;

			@media screen and (max-width: $xsmall) {
				grid-template-columns: 1fr;
				row-gap: 1.438rem;
			}
		}

		& > div.counter-offer {
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			column-gap: 1rem;
			grid-auto-rows: 1fr;
			width: 100%;

			@media screen and (max-width: $medium) {
				grid-template-columns: 1fr;
				row-gap: 1.438rem;
			}
		}
	}

	.tooltip-existing-offer__container {
		display: flex;
		flex-direction: column;
		gap: 4px;

		& > span {
			color: #000;
			font-family: Roboto, sans-serif;
			font-size: 12px;
			font-style: normal;
		}

		& > .tooltip-existing-offer__header {
			font-weight: 500;
			line-height: 20px;
		}

		& > .tooltip-existing-offer__text {
			font-weight: 400;
			line-height: 18px;
		}
	}
</style>
